/**
 * A dónde lleva una notificación. Siempre a la cosa concreta (la tarea, la cobertura), no a una pantalla general.
 * Lo usan la campanita, la pantalla de notificaciones y la tarjeta «Tus pendientes» del inicio.
 *
 * Los avisos que ya traen un link concreto (una tarea con `?focus=`, una lista de tareas con `?ids=`, un chat) se respetan.
 * Los que traen una pantalla general (/inicio, /kanban, /asignacion, un cockpit) se resuelven por lo que el aviso es:
 * si habla de una tarea o una cobertura, abre esa. Esto también arregla los avisos viejos, que quedaron guardados con el link general.
 */
const GENERALES = new Set(["", "/inicio", "/kanban", "/asignacion", "/cockpit", "/cockpit/coo", "/cockpit/ceo", "/coberturas-v2", "/pedidos-cliente"]);

export function enlaceDeNotif(n) {
  const link = String(n?.link || "").trim();
  const tipo = n?.entidad_tipo;
  const id = n?.entidad_id;
  if (link.startsWith("http")) return link;
  const general = GENERALES.has(link) || (link.startsWith("/clientes/") && tipo === "tarea");
  if (!general && link) return link;
  if (id) {
    if (tipo === "tarea") return `/tareas?focus=${encodeURIComponent(id)}`;
    if (tipo === "cobertura" || tipo === "cobertura-confirmada" || tipo === "cobertura-cancelada") return `/coberturas-v2?cobertura=${encodeURIComponent(id)}`;
    if (tipo === "cliente") return `/clientes/${id}`;
    if (tipo === "proyecto") return `/proyectos/${id}`;
    if (tipo === "content-plan") return `/generador-contenido?focus=${encodeURIComponent(id)}`;
    if (tipo === "factura") return "/facturacion";
  }
  return link || null;
}

/** Un aviso que trae una lista de tareas (`?ids=`): cuántas son, para decirlo en la propia notificación. */
export function cantidadDeTareasEnLink(link) {
  const m = String(link || "").match(/[?&]ids=([^&]+)/);
  return m ? m[1].split(",").filter(Boolean).length : 0;
}
